import { z } from "zod";

export const emailAddressSchema = z.string(); // TODO

export type EmailAddress = z.infer<typeof emailAddressSchema>;
